<template>
  <div id="about">
    <v-container :class="{ fluid: $vuetify.breakpoint.smAndDown }">
      <v-layout column align-content-center>
        <v-flex :ma-0="$vuetify.breakpoint.mdAndUp">
          <div
            id="introAbout"
            class="mainSections"
            :class="{ mainSectionsMobile: $vuetify.breakpoint.smAndDown }"
          >
            <div
              class="
                font-weight-medium
                blue-grey--text
                text--darken-4
                headline
                text-center
                subheaders
              "
            >
              <span class="logoText"> RETHYMOS</span> is a global advisory firm
              for Financial Markets <strong>participants </strong> and Financial
              Technology
              <strong> providers </strong>
            </div>
            <hr />
            <p
              class="title font-weight-light pt-3"
              :class="{ supportingParagraphs: $vuetify.breakpoint.mdAndUp }"
            >
              With deep experience in both trading, strategic consulting and
              technology, we are uniquely positioned to add value to companies
              and organizations of various sizes at multiple stages in the value
              chain. With relationships and expertise that spans across all
              major markets, our geographic footprint extends from our European
              base throughout Asia Pacific, the Middle East to the Americas. The
              essence of our work involves providing bespoke assistance to
              start-ups, scale-ups and established organizations including
              trading firms, brokers, exchanges (and other venues) and the
              vendors who seek to provide products and services to these
              participants.
            </p>
            <p
              class="title font-weight-light"
              :class="{ supportingParagraphs: $vuetify.breakpoint.mdAndUp }"
            >
              We are an atypical consulting firm in a sense that our approach is
              ‘boots on the ground’ and market driven, provided by three people
              who have 50+ years of multi-industry experience collectively as
              practitioners (not merely consultants). It is exactly this type of
              void that we attempt to fill, and is central to the value we
              provide to our clients.
            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <div
      class="parallax"
      :class="{ parallaxMobile: $vuetify.breakpoint.smAndDown }"
    ></div>
    <v-container :class="{ fluid: $vuetify.breakpoint.smAndDown }">
      <v-layout column align-content-center>
        <v-flex :ma-3="$vuetify.breakpoint.mdAndUp">
          <div
            id="moreAbout"
            class="mainSections"
            :class="{ mainSectionsMobile: $vuetify.breakpoint.smAndDown }"
          >
            <p
              class="
                font-weight-medium
                blue-grey--text
                text--darken-4
                headline
                text-center
                subheaders
              "
            >
              Our work involves assisting financial markets
              <strong> participants</strong> and the <strong> vendors</strong>
              that serve those participants
            </p>
            <hr />
            <p
              class="title font-weight-light pt-3"
              :class="{ supportingParagraphs: $vuetify.breakpoint.mdAndUp }"
            >
              We assist trading firms by providing market entry guidance and
              introductions to local market participants that can help to
              achieve their objectives, often presenting unique structuring
              alternatives to facilitate entry. We also work closely with
              industry vendors to access key adopters of new and interesting
              technologies. Trading firms who wish to enter new markets are
              often faced with a maze of alternatives, regulatory requirements,
              complex fee structures and other idiosyncrasies unique to most
              markets. Exchanges often look to introduce new products and
              services and need to sort through the different available best
              practices and technologies to deploy.
            </p>

            <p
              class="title font-weight-light"
              :class="{ supportingParagraphs: $vuetify.breakpoint.mdAndUp }"
            >
              Recognising there’s no standard protocol, the starting point in
              the process is a series of conversations with the management team
              of the trading or vendor organization to fully understand the
              products, services, value proposition, strategy and objectives. We
              will examine and vet the offering(s) at several levels, and
              attempt to understand the market feasibility. At times, clients
              have very broad objectives, perhaps a global rollout of a new
              brand or product and a desire to reach across multiple
              geographical and product vertical markets. Other times, the scope
              is very narrow in nature, and we might agree to pursue end user
              conversations with only a handful of targeted users. More often
              than not, the relevant assignment is somewhere between the two.
            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
export default {
  data() {
    return {
      displayLanding: true,
      items: ["Technology Services", "Business Development", "Employment"],
      navigationFill: [
        {
          destination: "/",
          icon: "info",
          tabName: "About Us",
        },
        {
          destination: "/technology",
          icon: "settings_input_component",
          tabName: "Technology Services",
        },
        {
          destination: "/business",
          icon: "business_center",
          tabName: "Business Development",
        },
        {
          destination: "/team",
          icon: "people",
          tabName: "Meet Our Team",
        },
      ],
    };
  },
  methods: {
    landingVisibility: function () {
      if (this.displayLanding == true) {
        this.displayLanding = false;
      }
    },
    ber: function () {
      console.log("logo emmit worked");
      if (this.displayLanding == false) {
        this.displayLanding = true;
        var elmnt = document.getElementById("about");
        elmnt.scrollIntoView(true);
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Play");
@import url("https://fonts.googleapis.com/css?family=Crimson+Text");

#about {
  background-color: white;
}

.parallax {
  background-image: url("/map2.png");
  height: 75vh;

  background-attachment: fixed;
  background-position: center;
  background-size: contain;
}

.parallaxMobile {
  background-image: url("/map2.png");
  height: 40vh;
  background-attachment: fixed;
  background-position: center;
  background-size: contain;
}

#background {
  background-color: black;
  opacity: 0.92;
  width: 60%;
  border-radius: 4px;
}

.headline {
  color: black;
  font-size: 25px;
  margin-bottom: 25px;
}

.mainSections {
  line-height: 1.8;
  padding: 6% 6%;
  margin-top: 5%;
  margin-bottom: 1%;
  background-color: white;
  border-radius: 5px;
}

.mainSectionsMobile {
  line-height: 1.6;
  background-color: white;
  border-radius: 5px;
}

.supportingParagraphs {
  margin: 35px;
  line-height: 1.6 !important;
}

.supportingParagraphsMobile {
  font-size: 16px;
  margin-top: 10px;
}

#worldMap {
  width: 100%;
}
</style>